import type { ImageQuota, ThemeImages } from '../api/types';

/**
 * 絵の状態と残り回数の言い方を 1 か所にまとめる（doc/AUTH.md §5）。
 * 入口ページ・自分のページ・管理メニューで同じ言葉を使う。
 */
export function imageStatusText(images: ThemeImages | null): string {
  if (!images) return '絵はありません';
  switch (images.status) {
    case 'pending':
      return 'まもなく絵を描きはじめます';
    case 'running':
      return `絵を描いています（${images.done} / ${images.total}）`;
    case 'done':
      return `絵ができています（${images.total} 枚）`;
    case 'partial':
      return `絵が一部だけできています（${images.done} / ${images.total}）`;
    case 'login_required':
      return 'ログインせずに作ったので、絵はありません';
    case 'quota':
      return 'その日の上限に達していたので、絵はまだありません';
    case 'skipped':
    default:
      return 'この環境では絵を描きません';
  }
}

/** 「今日あと n 回」。管理者は数えないので出さない。 */
export function QuotaNote({ quota, className = 'page__lead' }: { readonly quota: ImageQuota | null; readonly className?: string }) {
  if (!quota || quota.limit === null || quota.remaining === null) return null;
  if (quota.limit === 0) return <p className={className}>いまはキャラクターの絵を描くのを止めています。</p>;
  const resets = new Date(quota.resetsAt).toLocaleString('ja-JP', { month: 'numeric', day: 'numeric', hour: 'numeric' });
  return (
    <p className={className}>
      キャラクターの絵は <strong>今日あと {quota.remaining} 回</strong> 描けます（1 日 {quota.limit} 回まで、{resets} ごろに戻ります）。
    </p>
  );
}
